<template>
    <b-row class="text-center">
        <b-col class="mb-sm-2 mb-0">
        <div class="text-muted">Total em Moedas</div>
        <strong><small class="text-muted">R$</small> {{ $utils.numberFormat(item.coins) }}</strong>
        <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="item.coins * 100 / item.total"></b-progress>
        </b-col>
        <b-col class="mb-sm-2 mb-0 d-md-down-none">
        <div class="text-muted">Total em Cédulas</div>
        <strong><small class="text-muted">R$</small> {{ $utils.numberFormat(item.notes) }}</strong>
        <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="item.notes * 100 / item.total"></b-progress>
        </b-col>
        <b-col class="mb-sm-2 mb-0">
        <div class="text-muted">TOTAL</div>
        <strong><small class="text-muted">R$</small> {{ $utils.numberFormat(item.total) }}</strong>
        <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="item.total * 100 / item.total"></b-progress>
        </b-col>        
    </b-row>
</template>

<script>
export default {
  name: "ChangeControlFooterComponent",
  props: {
    controlitem: Object,
    controltype: Number
  },
  data() {
    return {
      item: this.controlitem,
      type: this.controltype
    }
  },
  methods: {
    
  }   
};

</script>
